import React from 'react';
import Login from '../../components/common/Login/Login';

const AdminLogin = () => {
  return <Login role="admin"  />;
};

export default AdminLogin;